import { GlobalResponseObject, GlobalVariableValues, MessageParameters } from "@gtpl/shared-models/common-models";
import { Injectable } from "@nestjs/common";
import { AttendanceHelperService } from "./attendance-helper.service";
import { AttendanceRepository } from "./repository/attendance.repository";
import { EmployeeAttendanceQueryResponse } from "./repository/emp-attn.query.response";
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast'
import { Cron } from "@nestjs/schedule";
import whatsApp from "apps/services/whatsapp";
import { WhatsAppLogDto } from "@gtpl/shared-models/whatsapp-broad-cast";
import { CommonResponse } from "@gtpl/shared-models/masters";
import { WhatsAppNotificationService } from "@gtpl/shared-services/notification-management";
import appSettings from "apps/services/config";
import { getManager } from "typeorm";


@Injectable()
export class WhatsappNotifyService {
    constructor(
        private attendanceHelperService: AttendanceHelperService,
        private attendanceRepo: AttendanceRepository,
        private wtsAppBroadCatService: WhatsappBroadCastService,
        private wpService: WhatsAppNotificationService
    ) {

    }
    // @Cron('15 11 * * *')
    async sendAttendanceStatus(): Promise<GlobalResponseObject> {
        try {
            const manager = getManager();
            let total = 0;
            // let urlMsg = '*click the below link for detail view*';
            // let attnUrl = appSettings.whatsapp_redirection_url + '/emp-monthwise-attendance-report';
            const currDate = new Date();
            const date = currDate.getFullYear() + '-' + (currDate.getMonth() + 1) + '-' + currDate.getDate();
            const time = currDate.getHours() + ':' + currDate.getMinutes() + ':' + currDate.getSeconds();
            const deptInfo = await this.attendanceHelperService.getAllDepartments();
            const deptNameMap = new Map<number, string>();
            deptInfo.forEach(dept => deptNameMap.set(dept.deptId, dept.deptName));
            // get all the tokens consumed
            const records: EmployeeAttendanceQueryResponse[] = await this.attendanceRepo.getAttendanceRecordsByDate(date);
            const empCount = await this.attendanceRepo.getShiftWiseEmpCountByDate(date);
            const wfhCount = await this.attendanceRepo.getWfhAttendanceRecordsByDate(date);
            const absentCount = await this.attendanceRepo.getAbsentAttendanceRecordsByDate(date);
            const leaveCount = await this.attendanceRepo.getLeaveAttendanceRecordsByDate(date);
            let totalCount = 0;
            let wfh = 0;
            let absent = 0;
            let leave = 0;
            for (const emp of empCount) {
                totalCount = emp.count;
            }
            for (const wfhEmp of wfhCount) {
                wfh = wfhEmp.count;
            }
            for (const absentEmp of absentCount) {
                absent = absentEmp.count;
            }
            for (const leaveEmp of leaveCount) {
                leave = leaveEmp.count;
            }
            let message = '';
            message += '\n';
            message += '         *Attendance Management System*            ';
            message += '\n';
            message += "\n";
            message += '*' + 'Attendance on' + ' ' + ' : ' + ' ' + date + ' ' + ' ' + time + '*';
            message += "\n";
            records.forEach(record => {
                message += "\n";
                // message += "*" + deptNameMap.get(record.department_id) + "*  :  *" + record.count + "*";
                message += "*" + 'Shift' + "*  :  *" + record.shift + "*";
                total += Number(record.count);
            });
            message += '\n';
            message += '\n';
            message += '*Total Employees  : ' + totalCount + '*';
            message += '\n';
            message += '*Present  : ' + total + '*';
            message += '\n';
            message += '*WFH  : ' + wfh + '*';
            message += '\n';
            message += '*Absent  : ' + absent + '*';
            message += '\n';
            message += '*Leave  : ' + leave + '*';
            message += '\n';
            message += '*Others  : ' + Number(Number(totalCount) - Number(total) - Number(wfh) - Number(absent) - Number(leave)) + '*';
            message += '\n';
            message += '\n';
            message += '\n';
            message += '\n';
            message += '*------------------------------*';
            message += '\n';
            let messageStatus
            const others = Number(Number(totalCount) - Number(total) - Number(wfh) - Number(absent) - Number(leave))
            const parameters = [
                { "type": "number", "number": totalCount },
                { "type": "number", "number": total },
                { "type": "number", "number": wfh },
                { "type": "number", "number": absent },
                { "type": "number", "number": leave },
                { "type": "number", "number": others }
            ]
            const contacts = whatsApp.contacts
            let statusFlag = true
            for (const contact of contacts) {
                const req = await new MessageParameters(contact, '', parameters, "en_us")
                const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
                console.log(messageStatus)
                if (!messageStatus.status) {
                    statusFlag = false
                } else {
                    statusFlag = true
                    const companyId = 7;
                    const hrmsModuleId = 2;
                    const whatsapplogDto = new WhatsAppLogDto(contact, 'marinex_usage_global', 'Sandhya', companyId, hrmsModuleId)
                    await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
                }
            }
            if (statusFlag) {
                return new CommonResponse(true, 11108, "Message Sent Sucessfully")
            }
        } catch (error) {
            console.log(error, 'error--')
            throw error;
        }
    }

    // @Cron('0 7 * * *')
    async sendworkingAttendanceStatus(): Promise<GlobalResponseObject> {
        try {
            let total = 0;
            function getPreviousDay(date = new Date()) {
                const previous = new Date(date.getTime());
                previous.setDate(date.getDate() - 1);
                return previous;
            }
            // let urlMsg = '*click the below link for detail view*';
            // let attnUrl = appSettings.whatsapp_redirection_url + '/emp-monthwise-attendance-report';
            const currDate = new Date();
            const date = currDate.getFullYear() + '-' + (currDate.getMonth() + 1) + '-' + currDate.getDate();
            const time = currDate.getHours() + ':' + currDate.getMinutes() + ':' + currDate.getSeconds();
            let monthstrtDate = '';
            if (currDate.getDate() == 1) {
                monthstrtDate = currDate.getFullYear() + '-' + currDate.getMonth() + '-' + '1';
            } else {
                monthstrtDate = currDate.getFullYear() + '-' + (currDate.getMonth() + 1) + '-' + '1';
            }
            const ystDate = getPreviousDay();
            const previousDate = ystDate.getFullYear() + '-' + (ystDate.getMonth() + 1) + '-' + ystDate.getDate();
            const deptInfo = await this.attendanceHelperService.getAllDepartments();
            const deptNameMap = new Map<number, string>();
            deptInfo.forEach(dept => deptNameMap.set(dept.deptId, dept.deptName));
            const records: EmployeeAttendanceQueryResponse[] = await this.attendanceRepo.getAttendanceRecordsByDate(previousDate);
            // const empCount = await this.attendanceRepo.getShiftWiseEmpCountByDate(previousDate);
            // const wfhCount = await this.attendanceRepo.getWfhAttendanceRecordsByDate(previousDate);
            // const absentCount = await this.attendanceRepo.getAbsentAttendanceRecordsByDate(previousDate);
            const top5WorkingHours = await this.attendanceRepo.getWorkingHoursTopRecordsByDate(monthstrtDate, previousDate);
            const swipeMissingCount = await this.attendanceRepo.getSwipeMissingTopRecordsByDate(monthstrtDate, previousDate);
            const wfhTopCount = await this.attendanceRepo.getTopWFHRecordsByDate(monthstrtDate, previousDate);
            const leaveTopCount = await this.attendanceRepo.getTopLeaveRecordsByDate(monthstrtDate, previousDate);
            const toptenabsentcount = await this.attendanceRepo.getTotalAbsentsInMonth(monthstrtDate, previousDate);
            // const toptenlessworkingcount = await this.attendanceRepo.getTotalLessWorkingHoursInMonth(monthstrtDate, previousDate);
            let totalCount = 0;
            // let wfh = 0;
            // let absent = 0;
            // let toptenabsent = 0;
            // let toptenlessworking = 0;
            // for (const emp of empCount) {
            //     totalCount = emp.count;
            // }
            // for (const wfhEmp of wfhCount) {
            //     wfh = wfhEmp.count;
            // }
            // for (const absentEmp of absentCount) {
            //     absent = absentEmp.count;
            // }
            // for (const absent of toptenabsentcount) {
            //     toptenabsent = absent.count
            // }
            // for (const absent of toptenlessworkingcount) {
            //     toptenlessworking = absent.count
            // }

            // if (records.length > 0) {
            //     const req = new BroadCastMessageRequest(28, message, [whatsApp.attendanceReport]);
            //     messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(req);
            // }
            // if (messageStatus) return new GlobalResponseObject(true, 0, 'whatsapp notification sent successfully');
            return new GlobalResponseObject(false, 11106, 'Message sending failed')
        } catch (error) {
            console.log(error, 'error--')
            throw error;
        }

    }

    @Cron('0 7 * * *')
    async sendworkingDailyAttendanceStatus(): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let total = 0;
            function getPreviousDay(date = new Date()) {
                const previous = new Date(date.getTime());
                previous.setDate(date.getDate() - 1);
                return previous;
            }
            // let urlMsg = 'click the below link for detail view';
            // let attnUrl = appSettings.whatsapp_redirection_url + '/emp-monthwise-attendance-report';
            const currDate = new Date();
            const date = currDate.getFullYear() + '-' + (currDate.getMonth() + 1) + '-' + currDate.getDate();
            const time = currDate.getHours() + ':' + currDate.getMinutes() + ':' + currDate.getSeconds();
            const ystDate = getPreviousDay();
            const previousDate = ystDate.getFullYear() + '-' + (ystDate.getMonth() + 1) + '-' + ystDate.getDate(); const deptInfo = await this.attendanceHelperService.getAllDepartments();
            const deptNameMap = new Map<number, string>();
            deptInfo.forEach(dept => deptNameMap.set(dept.deptId, dept.deptName));
            const records: EmployeeAttendanceQueryResponse[] = await this.attendanceRepo.getAttendanceRecordsByDate(previousDate);
            const empCount = await this.attendanceRepo.getDailyShiftWiseEmpCountByDate(previousDate);
            const wfhCount = await this.attendanceRepo.getWfhAttendanceRecordsByDate(previousDate);
            const absentCount = await this.attendanceRepo.getAbsentAttendanceRecordsByDate(previousDate);
            const leaveCount = await this.attendanceRepo.getLeaveAttendanceRecordsByDate(date);
            const workHoursRes = await this.attendanceRepo.getDailyWorkingHoursAttendanceRecordsByDate(previousDate, previousDate);
            const workHoursSm = await this.attendanceRepo.getDailyWorkingHoursAttendanceRecordsByDate(previousDate, previousDate);
            const punchMissing = await this.attendanceRepo.getDailyWorkingHoursAttendanceRecordsByDate(previousDate, previousDate);
            const punchMissingCount = punchMissing.sm
            const workingHoursCount = workHoursRes.lh;
            const workingHoursSmCount = workHoursSm.present;
            const top5WorkingHours = await this.attendanceRepo.getDailyWorkingHoursTopRecordsByDate(previousDate);
            const swipeMissingCount = await this.attendanceRepo.getDailySwipeMissingTopRecordsByDate(previousDate);
            const wfhTopCount = await this.attendanceRepo.getDailyTopWFHRecordsByDate(previousDate);
            const leaveTopCount = await this.attendanceRepo.getDailyTopLeaveRecordsByDate(previousDate);
            let totalCount = 0;
            let wfh = 0;
            let absent = 0;
            let leave = 0;
            for (const emp of empCount) {
                totalCount = emp.count;
            }
            for (const wfhEmp of wfhCount) {
                wfh = wfhEmp.count;
            }
            for (const absentEmp of absentCount) {
                absent = absentEmp.count;
            }
            for (const leaveEmp of leaveCount) {
                leave = leaveEmp.count;
            }

            let top5LessWorking = '';
            let top5OutPunchMiss = '';
            let top5WFH = '';
            let top5Leave = '';

            if (top5WorkingHours.length > 0) {
                for (const wh of top5WorkingHours) {
                    top5LessWorking += wh.employee_Name + " : " + wh.time_diff + " , ";
                }
            }
            if (swipeMissingCount.length > 0) {
                for (const op of swipeMissingCount) {
                    top5OutPunchMiss += op.employee_Name;
                }
            }
            if (wfhTopCount.length > 0) {
                for (const wfh of wfhTopCount) {
                    top5WFH += wfh.employee_Name;
                }
            }
            if (leaveTopCount.length > 0) {
                for (const lc of leaveTopCount) {
                    top5Leave += lc.employee_Name;
                }
            }

            const dateTime = date + " " + time

            const others = Number(Number(totalCount) - Number(total) - Number(wfh) - Number(absent) - Number(leave))
            const parameters = [
                { "type": "text", "text": previousDate },
                { "type": "text", "text": "General Shift" },
                { "type": "text", "text": totalCount },
                { "type": "text", "text": others },
                { "type": "text", "text": wfh },
                { "type": "text", "text": absent },
                { "type": "text", "text": leave },
                { "type": "text", "text": '-' },
                { "type": "text", "text": workingHoursCount },
                { "type": "text", "text": punchMissingCount },
                { "type": "text", "text": top5LessWorking ? top5LessWorking : '---' },
                { "type": "text", "text": top5OutPunchMiss ? top5OutPunchMiss : '---' },
                { "type": "text", "text": top5WFH ? top5WFH : '---'},
                { "type": "text", "text": top5Leave ? top5Leave : '---' },

            ]
            const contacts = whatsApp.contacts
            let statusFlag = true
            for (const contact of contacts) {
                const req = new MessageParameters(contact, 'attendance_report', parameters, "en_us")
                console.log(req,'req')
                const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
                console.log(messageStatus,'messageStatus')
                if (!messageStatus.status) {
                    statusFlag = false
                } else {
                    statusFlag = true
                    const companyId = 7;
                    const hrmsModuleId = 2;
                    const whatsapplogDto = new WhatsAppLogDto(contact, 'attendance_report', 'Sandhya', companyId, hrmsModuleId)
                    await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
                }
            }
            if (statusFlag) {
                return new CommonResponse(true, 11108, "Message Sent Sucessfully")
            }

        } catch (error) {
            console.log(error, 'error--')
            throw error;
        }
    }

    @Cron('0 10 * * *')
    async sendUnitWiseDailyAttendanceStatus(): Promise<GlobalResponseObject> {
        try {
            const manager = getManager();
            let total = 0;
            function getPreviousDay(date = new Date()) {
                const previous = new Date(date.getTime());
                previous.setDate(date.getDate() - 1);
                return previous;
            }
            // let urlMsg = 'click the below link for detail view';
            // let attnUrl = appSettings.whatsapp_redirection_url + '/emp-monthwise-attendance-report';
            const currDate = new Date();
            const date = currDate.getFullYear() + '-' + (currDate.getMonth() + 1) + '-' + currDate.getDate();
            const time = currDate.getHours() + ':' + currDate.getMinutes() + ':' + currDate.getSeconds();
            const ystDate = getPreviousDay();
            const previousDate = ystDate.getFullYear() + '-' + (ystDate.getMonth() + 1) + '-' + ystDate.getDate();
            // const deptInfo = await this.attendanceHelperService.getAllDepartments();
            // const deptNameMap = new Map<number, string>();
            // deptInfo.forEach(dept => deptNameMap.set(dept.deptId, dept.deptName));
            const unit1Data = await this.attendanceRepo.getDailyUnitWiseAttendanceRecordsByDate(previousDate, previousDate, 2);
            const unit2Data = await this.attendanceRepo.getDailyUnitWiseAttendanceRecordsByDate(previousDate, previousDate, 3);

            const dateTime = date + " " + time

            const others1 = Number(Number(unit1Data.totalCount) - Number(unit1Data.present) - Number(unit1Data.absent) - Number(unit1Data.leaves));
            const others2 = Number(Number(unit2Data.totalCount) - Number(unit2Data.present) - Number(unit2Data.absent) - Number(unit2Data.leaves));

            const parameters = [
                { "type": "text", "text": dateTime },
                { "type": "text", "text": previousDate },
                { "type": "text", "text": "Unit 1" },
                { "type": "text", "text": unit1Data.totalCount },
                { "type": "text", "text": unit1Data.present },
                { "type": "text", "text": unit1Data.leaves },
                { "type": "text", "text": unit1Data.absent },
                { "type": "text", "text": others1 },
                { "type": "text", "text": unit1Data.lh },
                { "type": "text", "text": unit1Data.sm },
                { "type": "text", "text": "Unit 2" },
                { "type": "text", "text": unit2Data.totalCount },
                { "type": "text", "text": unit2Data.present },
                { "type": "text", "text": unit2Data.leaves },
                { "type": "text", "text": unit2Data.absent },
                { "type": "text", "text": others2 },
                { "type": "text", "text": unit2Data.lh },
                { "type": "text", "text": unit2Data.sm },

            ]
            const contacts = whatsApp.contacts
            let statusFlag = true
            for (const contact of contacts) {
                const req = new MessageParameters(contact, 'unit_wise_daily_attendance_report', parameters, "en_us")
                const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
                if (!messageStatus.status) {
                    statusFlag = false
                } else {
                    statusFlag = true
                    const companyId = 7;
                    const hrmsModuleId = 2;
                    const whatsapplogDto = new WhatsAppLogDto(contact, 'unit_wise_daily_attendance_report', 'Sandhya', companyId, hrmsModuleId)
                    await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
                }
            }
            if (statusFlag) {
                return new CommonResponse(true, 11108, "Message Sent Sucessfully")
            }
        } catch (error) {
            console.log(error, 'error--')
            throw error;
        }
    }

}